<p class="debugMessage"><small>account-manage-organisation-groups:</small></p>
<ejs-splitter #horizontal height="calc(100vh - 220px)" separatorSize=4 width='100%' >
	<e-panes>
		<e-pane size='30%' min='5%'>
			<ng-template #content>
				<div style="margin-right: 5px;" *ngIf="selectedAccount">
					<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
						<span>System Groups</span>
						<span class="me-auto"></span>
					</nav>
					<ejs-listview id='listview-SystemGroups' #listviewInstance [dataSource]='accountSystemGroups'
						cssClass='e-list-template'>
						<ng-template #template let-dataSource>
							<div class="ejs-listview-item groupItem" (click)="selectGroup(dataSource)">
								<div style="padding-left: 1em;">
									<span class="alignRow app-icon app-icon--groups"><mat-icon />&nbsp;{{dataSource.Name}}</span>
								</div>
								<span class="me-auto"></span>
								<span><mat-icon>chevron_right</mat-icon></span>
							</div>
						</ng-template>
					</ejs-listview>
					<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
						<span>Custom User Groups</span>
						<span class="me-auto"></span>
						<span class="alignRow app-icon app-icon--add" *ngIf="selectedAccount.Admin" (click)="onAddGroup($event)">
							<mat-icon></mat-icon>
						</span>
					</nav>
					<ejs-listview id='listview-Groups' #listviewInstance [dataSource]='accountGroups'
						cssClass='e-list-template'>
						<ng-template #template let-dataSource>
							<div class="ejs-listview-item groupItem" (click)="selectGroup(dataSource)">
								<div style="padding-left: 1em;">
									<span class="alignRow app-icon app-icon--groups"><mat-icon />&nbsp;{{dataSource.Name}}</span>
								</div>
								<span class="me-auto"></span>
								<span><mat-icon>chevron_right</mat-icon></span>
							</div>
						</ng-template>
					</ejs-listview>
				</div>
			</ng-template>
		</e-pane>
		<e-pane>
			<ng-template #content>
				<div *ngIf="selectedGroup && selectedAccount" style="padding-left: 5px;" >
					<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
						<span><b>{{selectedGroup.Name}}</b></span>
						<span style="margin-left: 1em;">Receive Email:&nbsp;</span>
						<mat-checkbox class="example-margin" [disabled]="!selectedAccount.Admin" color="primary"
							(change)="patchGroup(selectedGroup)" [(ngModel)]="selectedGroup.ReceiveEmail">
						</mat-checkbox>
						<span class="me-auto"></span>
						<span class="app-icon app-icon--edit" *ngIf="selectedAccount.Admin && !selectedGroup.SystemGroup"
							(click)="updateGroupName(selectedGroup)">
							<mat-icon />
						</span>
						<span class="app-icon app-icon--delete" *ngIf="selectedAccount.Admin && !selectedGroup.SystemGroup"
							(click)="deleteGroup(selectedGroup)">
							<mat-icon />
						</span>
					</nav>
					<div class="groupBox">
						<span><b>Users</b></span>
						<ng-container
							*ngIf="(selectedGroup && accountGroupUsers) then grpUsers else noUsers"></ng-container>
						<ng-template #noUsers>
							<div>No Users Found</div>
						</ng-template>
						<ng-template #grpUsers>
							<div>
								<mat-checkbox *ngFor="let user of accountGroupUsers" class="example-margin"
									color="primary" [disabled]="!selectedAccount.Admin || selectedGroup.SystemGroup"
									(change)="updateGroupUsers(selectedGroup.AccountGroupID)"
									[(ngModel)]="user.Selected">
									{{user.Name}}
								</mat-checkbox>
							</div>
						</ng-template>
					</div>
				</div>
			</ng-template>
		</e-pane>
	</e-panes>
</ejs-splitter>